module.exports = __webpack_public_path__ + "static/media/VIP_Purple@3x.5fffa8e9.png";